import { PartecipanteItem } from "@/models/ricercaGaranzie/partecipanteItem";
import api from "@/services/api";
import apiFile from "@/services/apiFile";
import { Component } from "vue-property-decorator";
import gridComponentBase from "../components/grid/gridComponentBase.vue";
import { process } from "@progress/kendo-data-query";
import helpers from "@/helpers";
import { Filter } from "@/models/grid/filter";
import { getTuoiAcquistiColumns } from "@/columns/tuoiAcquistiColumns";

const _ENDPONT = api.endpoint.MY_OVERINS.ELENCO_ADESIONI_DISTRIBUTORE;

@Component({})
export default class TuoiAcquistiPage extends gridComponentBase {
	get columns(): Array<any> {
		return getTuoiAcquistiColumns(this);
	}

	get columnsMobile(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, cell: "defaultCellTemplate", headerCell: "myHeaderCellTemplate", editHide: true },

			{ field: "numeroCompleto", title: "Adesione", width: 130, headerCell: "myHeaderCellTemplate", export: true },
			{ field: "utente", title: "Utente", width: 100, headerCell: "myHeaderCellTemplate", export: true },
			{ field: "pacchetto", title: this.$i18n.t("generico.prodotto").toString(), headerCell: "myHeaderCellTemplate", export: true, width: 150 },
			{
				field: "dataInserimento",
				title: "Data Acquisto",
				format: "{0:dd/MM/yyyy}",
				width: 150,
				headerCell: "myHeaderCellTemplate",
				type: "date",
				headerType: "daterange",
				export: true,
				exportRenderFunction: this.exportRenderDate
			},
			{ field: "anno", title: "Anno", format: "{0:yyyy}", width: 90, headerCell: "myHeaderCellTemplate", type: "date", headerType: "daterange", filterable: false, sortable: false },
			{
				field: "inizioViaggio",
				title: "Inizio",
				format: "{0:dd/MM/yyyy}",
				width: 120,
				headerCell: "myHeaderCellTemplate",
				type: "renderfunction",
				headerType: "daterange",
				export: true,
				renderFunction: this.renderFunctionNoTimeZoneDate,
				exportRenderFunction: this.exportRenderDate
			},
			{
				field: "fineViaggio",
				title: "Fine",
				format: "{0:dd/MM/yyyy}",
				width: 120,
				headerCell: "myHeaderCellTemplate",
				type: "renderfunction",
				headerType: "daterange",
				export: true,
				renderFunction: this.renderFunctionNoTimeZoneDate,
				exportRenderFunction: this.exportRenderDate
			},
			{
				field: "partecipantiElenco",
				title: "Partecipanti",
				type: "renderfunction",
				renderFunction: this.renderCellPartecipantiElenco,
				headerCell: "myHeaderCellTemplate",
				export: true,
				exportRenderFunction: this.exportRenderPartecipanti,
				exportWidth: 600
			},
			{ field: "destinazione", title: "Destinazione", hidden: false, headerCell: "myHeaderCellTemplate", export: true },
			{
				field: "importoViaggio",
				title: "Importo",
				format: "{0:n2}",
				width: 90,
				headerCell: "myHeaderCellTemplate",
				headerType: "numeric",
				export: true,
				type: "renderfunction",
				renderFunction: this.renderCellImportoViaggio,
				exportRenderFunction: this.renderCellImportoViaggio
			},
			{ field: "totalePremio", title: "Premio", format: "{0:n2}", width: 80, headerCell: "myHeaderCellTemplate", type: "numeric", headerType: "numeric", export: true }
		];
	}

	created() {
		if (!(this.isAppMobile == false)) {
			this.pageable["buttonCount"] = 3;
			this.pageable["info"] = false;
			this.pageable["pageSizes"] = undefined;
		}
	}

	mounted() {
		this.getData();
	}

	renderCellPdfCopertura(data: string) {
		var result = `<a href='/file/adesione/${data}' target='_blank' style='color: #5cb85c;'>Apri</a>`;

		return result;
	}

	renderCellPartecipantiElenco(data: string) {
		var array = JSON.parse(data) as PartecipanteItem[];
		let innerHtml = data;
		if (array && array.length > 0) {
			innerHtml = array
				.map(function(item) {
					return `${item.Cognome} ${item.Nome} `;
				})
				.join(", ");
		}
		var result = `<div style='display:block; overflow:hidden;max-height:30px;'>${innerHtml}</div>`;

		return result;
	}

	exportRenderPartecipanti(data: string) {
		var array = JSON.parse(data) as PartecipanteItem[];
		let innerHtml = data;
		if (array && array.length > 0) {
			innerHtml = array
				.map(function(item) {
					return `${item.Cognome} ${item.Nome} `;
				})
				.join(", ");
		}
		return innerHtml;
	}

	renderCellImportoViaggio(data: number, a: any) {
		if (a.secondoImporto && a.secondoImporto > 0) return kendo.toString(a.secondoImporto, "n2");
		return kendo.toString(data || 0, "n2");
	}

	getPartecipanti(data: string) {
		var array = JSON.parse(data) as PartecipanteItem[];
		let partecipanti: string[] = [];
		if (array && array.length > 0) {
			partecipanti = array.map(function(item) {
				return `${item.Cognome} ${item.Nome}`;
			});
		}
		return partecipanti;
	}

	exportExcel() {
		this.exportGridExcel(_ENDPONT);
	}

	getData() {
		this.getGridData(_ENDPONT);
	}

	downloadAdesioneFile(guid) {
		var self = this;
		var url = `adesione/${guid}`;
		var nomeFile = "CertificatoAssicurativo.pdf";
		apiFile
			.downloadFile(url, nomeFile)
			.then(response => {
				const blob = new Blob([response.data], { type: "application/pdf" });
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = nomeFile;
				link.click();
				URL.revokeObjectURL(link.href);
			})
			.catch(err => {
				console.log(err);
				var msg = this.$i18n.t("errore.fileDaScaricareNonTrovato").toString();
				self.$bvToast.toast(msg, {
					variant: "danger",
					title: self.$i18n.t("msg.erroreGenerico").toString(),
					solid: true
				});
			});
	}

	downloadFileImmaginePartecipanti(path) {
		var self = this;
		//var url = `file?name=${path}`;
		var url = `imgPartecipanti?name=${path}`;
		var nomeFile = path.substring(path.lastIndexOf("/") + 1);
		apiFile
			.downloadFile(url, "")
			.then(response => {
				const blob = new Blob([response.data], { type: response.headers["content-type"] });
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = nomeFile;
				link.click();
				URL.revokeObjectURL(link.href);
			})
			.catch(err => {
				console.log(err);
				var msg = this.$i18n.t("errore.fileDaScaricareNonTrovato").toString();
				self.$bvToast.toast(msg, {
					variant: "danger",
					title: self.$i18n.t("msg.erroreGenerico").toString(),
					solid: true
				});
			});
	}

	get gridDataExpanded() {
		if (this.itemsGrid && this.itemsGrid.length) {
			var items = this.itemsGrid.map(function(item) {
				item.anno = kendo.format("{0:yyyy}", item.dataInserimento);
				return item;
			});

			return process(items, { take: this.take, skip: 0, group: this.group });
		}

		return [];
	}

	expandChangeCustom(dataItem){
		var self = this;
		if( !dataItem.dettaglio){
			api.get(`${api.endpoint.MY_OVERINS.ELENCO_ADESIONI}/${dataItem.itemID}`).then(res =>{
				dataItem.dettaglio = res
				self.expandChange(dataItem);
			})
		}
		else
			self.expandChange(dataItem);
	}

	getTestoTipoApplicazione(data: any) {
		return data.secondoImporto ? helpers.getTipoApplicazioneLabelAlloggi(data.tipoApplicazione) : "Alloggi";
	}

	getUlterioriDatiValore(item) {
		return helpers.getUlterioriDatiValore(item);
	}

	getDatiAggiuntivi(item) {
		return item.datiAggiuntivi ? JSON.parse(atob(item.datiAggiuntivi)) : null;
	}

	showfilterDialog: boolean = false;

	onApplyFiltersMobile(filtersMobile: Filter) {
		this.filter = filtersMobile;
		this.onFilterMobileApply();
		this.onCloseDialogMessage();
	}
	onRemoveAllFilters() {
		this.clearSortAndFilter();
		//this.onCloseDialogMessage();
	}

	onCloseDialogMessage() {
		this.showfilterDialog = false;
	}

	onOpenFilterDialog() {
		this.showfilterDialog = true;
	}
}
